import { SchemaColumnOptions, SchemaTableOptions } from "@/vendors/prx-sqlite/Interfaces/SchemaInterfaces";

export const telcpus:SchemaTableOptions = {
    name:<string> 'telcpus',
    schema:<Array<SchemaColumnOptions>> [
        { column: 'id', value: 'INTEGER PRIMARY KEY AUTOINCREMENT'},
        { column: 'name', value: 'VARCHAR(255) NOT NULL'},
        { column: 'telcpu_location_id', value: 'INTEGER UNSIGNED'},
    ]
}